"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputMoneyWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _InputMoneyWindowModule = _interopRequireDefault(require("./InputMoneyWindow.module.scss"));

var _InputMoneyWindow = _interopRequireDefault(require("./InputMoneyWindow.i18n"));

var _inputElements = require("../../../inputElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// eslint-disable-next-line complexity
function InputMoneyWindow(_ref) {
  var initialValues = _ref.initialValues,
      minValues = _ref.minValues,
      maxValues = _ref.maxValues,
      onSubmit = _ref.onSubmit,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)((initialValues === null || initialValues === void 0 ? void 0 : initialValues.pp) || 0),
      _useState2 = _slicedToArray(_useState, 2),
      valuePP = _useState2[0],
      setValuePP = _useState2[1];

  var _useState3 = (0, _react.useState)((initialValues === null || initialValues === void 0 ? void 0 : initialValues.gp) || 0),
      _useState4 = _slicedToArray(_useState3, 2),
      valueGP = _useState4[0],
      setValueGP = _useState4[1];

  var _useState5 = (0, _react.useState)((initialValues === null || initialValues === void 0 ? void 0 : initialValues.cp) || 0),
      _useState6 = _slicedToArray(_useState5, 2),
      valueCP = _useState6[0],
      setValueCP = _useState6[1];

  var handleOnSubmit = (0, _react.useCallback)(function () {
    if (onSubmit) onSubmit({
      pp: valuePP,
      gp: valueGP,
      cp: valueCP
    });
  }, [onSubmit, valuePP, valueGP, valueCP]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_InputMoneyWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _InputMoneyWindowModule.default.dragHandler,
    classNameCloseBtn: _InputMoneyWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _InputMoneyWindowModule.default.label
  }, formatMessage(_InputMoneyWindow.default.cost)), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    className: _InputMoneyWindowModule.default.pp,
    type: "number",
    value: valuePP,
    min: (minValues === null || minValues === void 0 ? void 0 : minValues.pp) || 0,
    max: (maxValues === null || maxValues === void 0 ? void 0 : maxValues.pp) || Number.MAX_SAFE_INTEGER,
    onChange: function onChange(event) {
      return setValuePP(Number.parseInt(event.target.value, 10) || 0);
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    className: _InputMoneyWindowModule.default.gp,
    type: "number",
    value: valueGP,
    min: (minValues === null || minValues === void 0 ? void 0 : minValues.gp) || 0,
    max: (maxValues === null || maxValues === void 0 ? void 0 : maxValues.gp) || Number.MAX_SAFE_INTEGER,
    onChange: function onChange(event) {
      return setValueGP(Number.parseInt(event.target.value, 10) || 0);
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    className: _InputMoneyWindowModule.default.cp,
    type: "number",
    value: valueCP,
    min: (minValues === null || minValues === void 0 ? void 0 : minValues.cp) || 0,
    max: (maxValues === null || maxValues === void 0 ? void 0 : maxValues.cp) || Number.MAX_SAFE_INTEGER,
    onChange: function onChange(event) {
      return setValueCP(Number.parseInt(event.target.value, 10) || 0);
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MONEY,
    className: _InputMoneyWindowModule.default.btnAdd,
    onClick: handleOnSubmit
  }, formatMessage(_InputMoneyWindow.default.add)));
}